import {Component, Injector, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {UntypedFormGroup} from '@angular/forms';
import {ToastService} from '../../../../main/services';
import {TenderAnalyticsSettingsService} from '../../../services';
import {PaymentMethodsCollection} from '../../../../common/models/payment-method';
import {PaymentTypesCollection} from '../../../../common/models/payment-type';
import {PAYMENT_TYPES} from '../../../../common/models/payment-type/payment-types';
import {FuelPreferenceCollection} from '../../../../common/models/fuel-preference';
import {DECIMAL_MASK} from '../../../../common/helpers';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {InputCurrentContractModalComponent} from '../../../components';
import {Tender, TenderInputCurrentOffer} from '../../../models';


@Component({
    selector: 'jft-input-current-contract',
    templateUrl: './input-current-contract.component.html',
    styleUrls: ['input-current-contract.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class InputCurrentContractComponent implements OnInit {
    public decimalMask = DECIMAL_MASK;
    public form: UntypedFormGroup;
    public currentOffers: TenderInputCurrentOffer[];
    public loading: boolean = false;
    public tenderId: string;

    public paymentMethodsCollection: PaymentMethodsCollection;
    public paymentTypesCollection: PaymentTypesCollection;
    public PAYMENT_TYPES = PAYMENT_TYPES;
    public fuelPreferenceCollection: FuelPreferenceCollection;
    public tender: Tender;

    constructor(
        protected route: ActivatedRoute,
        private service: TenderAnalyticsSettingsService,
        private toast: ToastService,
        public ngbModal: NgbModal,
        public injector: Injector,
    ) {

    }
    public ngOnInit() {
        let data = this.route.snapshot.data;
        let parentData = this.route.snapshot.parent.data;
        this.tenderId = this.route.snapshot.parent.parent.params.id;
        this.currentOffers = data['inputCurrentOffer'];
        this.tender = this.route.snapshot.parent.parent.data['tender'];
    }

    public addCurrentContract() {
        this.create();
    }

    public editCurrentContract(offer: TenderInputCurrentOffer) {
        this.openContract(offer);
    }

    public deleteCurrentContract(offer: TenderInputCurrentOffer) {
        this.service.deleteInputCurrentOffer(this.tenderId, offer.id).subscribe(() => {
                this.loading = false;
                this.updateList();
            }, (e) => {
                this.loading = false;
                this.toast.error(e);
            });
    }

    private openContract(offer: TenderInputCurrentOffer) {
        const addDialogRef = this.ngbModal.open(InputCurrentContractModalComponent, {
            injector: Injector.create([
                {provide: String, useValue: 'add'}], this.injector),
            centered: true,
            size: 'lg',
        });

        addDialogRef.componentInstance.formType = 'add';
        addDialogRef.componentInstance.inputCurrentOffer = offer;
        addDialogRef.componentInstance.tender = this.tender;

        addDialogRef.result.then(result => {
            if (result.success) {
                this.updateList();
                //this.getUserList();
            }
        })
            .catch(err => { /* dialog dismissed */
                this.updateList();
            });
    }

    public updateList() {
        this.service.fetchInputCurrentContract(this.tenderId).subscribe((currentOffers: TenderInputCurrentOffer[]) => {
                this.loading = false;
                this.currentOffers = currentOffers
            }, (e) => {
                this.loading = false;
                this.toast.error(e);
            });
    }

    public create() {
        this.loading = true;
        this.service.createInputCurrentOffer(this.tenderId, {}).subscribe((currentOffer: TenderInputCurrentOffer) => {
                this.loading = false;
                this.editCurrentContract(currentOffer);
            }, (e) => {
                this.loading = false;
                this.toast.error(e);
        });
    }
}
